import { render, staticRenderFns } from "./IconButtonDropdown.vue?vue&type=template&id=72490add&"
import script from "./IconButtonDropdown.vue?vue&type=script&lang=js&"
export * from "./IconButtonDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports